document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const form = root.querySelector('[data-product-form]');
    const variantData = root.querySelector('[data-product-variants]');
    if (!form || !variantData) return;
    let variants = [];
    try { variants = JSON.parse(variantData.textContent || '[]'); } catch (error) { return; }
    const selects = Array.from(form.querySelectorAll('[data-option-index]'));
    const swatchGroups = Array.from(root.querySelectorAll('[data-color-swatches]'));
    const stickyQuantity = document.querySelector('[data-sticky-quantity]');
    const quantityInput = form.querySelector('[name="quantity"]');

    const syncSwatches = () => {
      swatchGroups.forEach((group) => {
        const optionIndex = Number(group.dataset.optionIndex);
        const select = selects[optionIndex];
        if (!select) return;
        const indicator = group.closest('.pdp-option')?.querySelector('[data-color-indicator]');
        group.querySelectorAll('[data-color-value]').forEach((button) => {
          const choices = selects.map((item) => item.value);
          choices[optionIndex] = button.dataset.colorValue;
          const matches = variants.filter((variant) => variant.options.every((value, index) => index === optionIndex || value === choices[index]));
          const active = select.value === button.dataset.colorValue;
          button.classList.toggle('is-active', active);
          button.classList.toggle('is-sold-out', matches.length > 0 && !matches.some((variant) => variant.available));
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
          button.disabled = matches.length === 0;
          if (active && indicator) indicator.style.setProperty('--option-color', button.style.getPropertyValue('--swatch-color'));
        });
      });
    };

    swatchGroups.forEach((group) => {
      const optionIndex = Number(group.dataset.optionIndex);
      group.querySelectorAll('[data-color-value]').forEach((button) => button.addEventListener('click', () => {
        const select = selects[optionIndex];
        if (!select || button.disabled) return;
        select.value = button.dataset.colorValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }));
    });
    selects.forEach((select) => select.addEventListener('change', syncSwatches));

    const syncQuantity = () => { if (quantityInput && stickyQuantity) stickyQuantity.value = Math.max(1, Number(quantityInput.value) || 1); };
    quantityInput?.addEventListener('change', syncQuantity);
    form.querySelector('[data-qty-minus]')?.addEventListener('click', syncQuantity);
    form.querySelector('[data-qty-plus]')?.addEventListener('click', syncQuantity);

    const stickyBar = document.querySelector('[data-sticky-product-bar]');
    const mainBuy = root.querySelector('[data-main-buy]');
    if (stickyBar && mainBuy) {
      const mobile = window.matchMedia('(max-width: 760px)');
      const updateSticky = () => {
        const visible = mobile.matches || mainBuy.getBoundingClientRect().bottom < 88;
        stickyBar.classList.toggle('is-visible', visible);
        stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      };
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      if (typeof mobile.addEventListener === 'function') mobile.addEventListener('change', updateSticky);
      else if (typeof mobile.addListener === 'function') mobile.addListener(updateSticky);
      updateSticky();
    }
    syncSwatches();
    syncQuantity();
  });
});
